import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import axios from 'config/axios';
import { FeedCoverageInfo } from '../feeds.types';

type StandardRes = {
  latest?: FeedCoverageInfo;
  latestSuccessful?: FeedCoverageInfo;
};

type NoContentRes = {
  latest: null;
  latestSuccessful: null;
};

type Response = StandardRes | NoContentRes;

async function getLatestFeedCoverageInfo(purposeId: string) {
  const response = await axios.get<Response>(
    `GetLatestFeedCoverageInfo?purposeId=${purposeId}`
  );

  if (response.status === 204) {
    return { latest: null, latestSuccessful: null };
  }

  return response.data;
}

const useLatestFeedCoverageInfo = (purposeId: string) =>
  useQuery<Response, AxiosError>(['feedLatestCoverage', purposeId], () =>
    getLatestFeedCoverageInfo(purposeId)
  );

export default useLatestFeedCoverageInfo;
